module.exports = require("./vai-Latn-LR.js");